import { Platform } from 'react-native';

import AxiosError from 'axios-error';
import { format } from 'date-fns';
import store from 'store';

import { DEVICE_TYPE } from 'config/api';

import { setLastProvisionDate } from 'store/user/actions';
import { selectLanguage } from 'store/user/selectors';

import { ROOT_ENDPOINTS } from 'utils/axios/nagra/consts';
import { extractRoot } from 'utils/axios/nagra/utils';
import { isTablet } from 'utils/responsiveness';

export const request = (defaultConfig: any) => {
    const languageToLocale = {
        en: 'en_GB',
        hu: 'hu_HU',
    };
    const state = store.getState();
    const selectedLanguage = selectLanguage(state) as 'en' | 'hu';

    const cacheControlHeaders =
        extractRoot(defaultConfig.url) === ROOT_ENDPOINTS.CONTENT_DELIVERY
            ? {}
            : {
                  'Cache-Control': 'no-cache',
              };

    store.dispatch(
        setLastProvisionDate(format(new Date(), 'yyyy-MM-dd HH:mm:ss')),
    );

    return {
        ...defaultConfig,
        headers: {
            ...defaultConfig.headers,
            ...cacheControlHeaders,
            'Accept-Language': languageToLocale[selectedLanguage],
            'Nagra-Device-Type': DEVICE_TYPE,
            'Nagra-Target': Platform.select({
                ios: isTablet ? 'tablet' : 'mobile',
                android: isTablet ? 'tablet' : 'mobile',
                web: 'tv',
            }),
            Pragma: 'no-cache',
            Expires: '0',
        },
    };
};

export const response = (resp: any) => {
    // @ts-ignore
    if (resp?.data?.resultCode?.includes('403')) {
        throw new AxiosError('401', {
            config: resp.config,
            request: resp.request,
            response: {
                ...resp,
                status: 401,
            },
        });
    }

    return resp;
};
